import type { Membership } from '@performance-crm/shared';
import { createContext, useContext } from 'react';

export interface CompanyScopeState {
  /** Empresas del usuario (sin repetir). */
  companies: Membership[];
  /** La única empresa si solo tiene una. */
  single: string | undefined;
  /** Empresa activa del selector global (persistida): la única, la elegida o la primera. */
  active: string | undefined;
  setActive: (companyId: string) => void;
}

export const CompanyContext = createContext<CompanyScopeState>({
  companies: [],
  single: undefined,
  active: undefined,
  setActive: () => undefined,
});

export function useCompanyScope() {
  return useContext(CompanyContext);
}
